import React, { useState } from 'react';
import { MenuItem, Menu, CircularProgress } from '@material-ui/core';
import cc from 'classnames';
import Button, { Themes as ButtonThemes } from 'ui/Button/Button';
import { ITransactionReportCardProps } from './transactionCard.model';

import styles from './TransactionReportCard.module.css';

import dssCertified from 'assets/icons/DSS_certified.svg';
import ismsCertified from 'assets/icons/ISMS_certified.svg';
import wordDoc from 'assets/icons/word_doc.svg';
import excelDoc from 'assets/icons/excel_doc.svg';
import pdfDoc from 'assets/icons/pdf_doc.svg';


const TransactionReportCard = ({
  header,
  fields,
  className,
  onClose,
  submitting,
  onSubmit,
}: ITransactionReportCardProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement | any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type: string) => {
    setAnchorEl(null);
    if (typeof type === 'string') {
      onSubmit(type);
    }
  };

  const getRows = () =>
    fields?.filter((item) => item?.label !== 'Source Account:').map(({ label, value }) => (
      <div key={String(label)} className={styles.line}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>{value}</div>
      </div>
    ));

  const getObscuredAccountNumber = () => {
    const accountNumber = fields.find((item) => item.label === 'Source Account:')?.value?.toString() || '';
    const obscureAccount = `xxxxx${accountNumber?.substring(0, accountNumber.length / 2)}`;

    return obscureAccount;
  };

  return (
    <section className={cc(styles.card, className)}>
      {header}
      <div className={styles.rowBody}>
        <div className={styles.payerContainer}>
          <div className={styles.payerInfo}>
            <p className={styles.payerInfoText}>Payer Information</p>
            <div className={styles.lineTwo}>
              <div className={styles.label}>Source Account</div>
              <div className={styles.value}>{getObscuredAccountNumber()}</div>
            </div>
            <div className={styles.lineTwo}>
              <div className={styles.label}>Payer Name</div>
              <div className={styles.value}>{fields.find((item) => item.label === 'Payer Name:')?.value}</div>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <img src={dssCertified} alt="DSS_certified" />
            <img src={ismsCertified} alt="ISMS_certified" />
          </div>
        </div>
        <p className={styles.payerInfoText}>Transaction Information</p>
        <div className={styles.rowContainer}>
          <div className={styles.rowsDetails}>
            {getRows().slice(0, 5)}
          </div>
          <div className={styles.rowsDetails}>
            {getRows().slice(5, getRows().length)}
          </div>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          theme={ButtonThemes.secondary}
          fullWidth
          className={styles.button}
          onClick={onClose}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          className={styles.button}
          disabled={submitting}
          id="demo-positioned-button"
          aria-controls={open ? 'demo-positioned-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          {!submitting ? 'Download Advice' : <CircularProgress size={20} color="inherit" />}
        </Button>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
            style: { width: anchorEl && anchorEl.offsetWidth }, // <-- The line that does all
          }}
          PaperProps={{
            style: {
              transform: 'translateX(0%) translateY(50%)',
            },
          }}
          keepMounted={false}
        >
          <MenuItem onClick={() => handleClose('excel')}>
            <img src={excelDoc} alt="excel icon" className={styles.downloadIcon} />
            Excel
          </MenuItem>
          <MenuItem onClick={() => handleClose('pdf')}>
            <img src={pdfDoc} alt="pdf icon" className={styles.downloadIcon} />
            PDF
          </MenuItem>
          <MenuItem onClick={() => handleClose('word')}>
            <img src={wordDoc} alt="word icon" className={styles.downloadIcon} />
            Word
          </MenuItem>
        </Menu>

      </div>
    </section>
  );
};

export default TransactionReportCard;
